"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeWeeklyVelocityToJSON = exports.EmployeeWeeklyVelocityFromJSONTyped = exports.EmployeeWeeklyVelocityFromJSON = void 0;
function EmployeeWeeklyVelocityFromJSON(json) {
    return EmployeeWeeklyVelocityFromJSONTyped(json, false);
}
exports.EmployeeWeeklyVelocityFromJSON = EmployeeWeeklyVelocityFromJSON;
function EmployeeWeeklyVelocityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'velocity': json['velocity'],
        'issues': json['issues'],
    };
}
exports.EmployeeWeeklyVelocityFromJSONTyped = EmployeeWeeklyVelocityFromJSONTyped;
function EmployeeWeeklyVelocityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'velocity': value.velocity,
        'issues': value.issues,
    };
}
exports.EmployeeWeeklyVelocityToJSON = EmployeeWeeklyVelocityToJSON;
